import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'group-editor-basic',
    template: `
        <div fxFlex fxLayout="column" [formGroup]="form">
            <mat-form-field>
                <input matInput placeholder="Name" formControlName="name">
                <mat-error *ngIf="form.get('name').hasError('required')">Name is required.</mat-error>
            </mat-form-field>
            <mat-form-field>
                <input matInput placeholder="Description" formControlName="description">
            </mat-form-field>
            <div fxLayout="row">
                <mat-checkbox *ngIf="allowAutoAddNewUsers"
                            formControlName="autoAddNewUsers">
                    Automatically add new users
                </mat-checkbox>
                <mat-checkbox formControlName="allowUsersToJoin" [fxFlexOffset]="allowAutoAddNewUsers ? '20px' : '0'">
                    Allow users to join this group
                </mat-checkbox>
            </div>
        </div>
    `
})
export class GroupEditorBasicComponent {
    @Input() form: FormGroup;
    @Input() allowAutoAddNewUsers = false;
}